import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import buySteps from "../buySteps";

const SureStepBuy_3 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.step_2);
  };

  const handleYesStep = () => {
    goToStep(buySteps.sureSteps.swap.step_1);
  };

  const handleNoStep = () => {
    goToStep(buySteps.sureSteps.buy.step_1);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        yesStep={handleYesStep}
        noStep={handleNoStep}
        text="У вас есть квартира, которую вы планируете продать для покупки новой?"
      />
    </div>
  );
};

export default SureStepBuy_3;
